import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { debounceTime, tap } from 'rxjs';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AppMapLocation, AppMapLocations } from 'app/shared/interfaces/map.model';
import { AppMapComponent } from '../map.component';
import { InfoTooltipComponent } from '../info-tooltip.component';

import { injectDestroy } from 'ngxtension/inject-destroy';

@UntilDestroy()
@Component({
  selector: 'formly-field-address',
  template: `
    <!--    <h3 class="mb-2">-->
    <!--      {{ props.label }}-->
    <!--      <app-info-tooltip [tooltip]="props.info"></app-info-tooltip>-->
    <!--    </h3>-->
    <div class="block">
      @for (field of field.fieldGroup; track $index) {
        <formly-field [field]="field" [class]="field.props.className"></formly-field>
      }
      <!--      <div class="block h-60 mb-4">-->
      <!--        <app-map [locations]="locations"></app-map>-->
      <!--      </div>-->
      @if (field.props.description) {
        <mat-hint class="inline-block mb-2">{{ field.props.description }}</mat-hint>
      }
    </div>
  `,
  imports: [ReactiveFormsModule, FormlyModule, MatFormFieldModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldGeolocationComponent extends FieldType implements AfterViewInit {
  locations: AppMapLocations = [];
  destroy$ = injectDestroy();

  constructor(private readonly cdr: ChangeDetectorRef) {
    super();
  }

  locationCheck(geolocation: AppMapLocation): boolean {
    const lat: number | undefined = Number(geolocation.latitude);
    const long: number | undefined = Number(geolocation.longitude);

    return (
      typeof lat === 'number' &&
      Number.isFinite(lat) &&
      lat > -181 &&
      lat < 181 &&
      typeof long === 'number' &&
      Number.isFinite(long) &&
      long > -91 &&
      long < 91
    );
  }

  // --- Lifecycle

  ngAfterViewInit(): void {
    this.field.formControl.valueChanges
      .pipe(
        // untilDestroyed takes the @UntilDestroy()-decorated INSTANCE. this.destroy$ does not
        // exist on this class, so the operator threw on every geolocation field the moment
        // ngAfterViewInit ran - the field never rendered at all.
        untilDestroyed(this),
        debounceTime(200),
        tap(event => {
          const geolocation: AppMapLocation = {
            latitude: event.latitude !== '' ? event.latitude : undefined,
            longitude: event.longitude !== '' ? event.longitude : undefined,
            markerColor: 'primary',
          };

          this.field.formControl.get('geolocation').patchValue(JSON.stringify(geolocation), { emitEvent: false });

          this.locations = this.locationCheck(geolocation)
            ? [
                {
                  latitude: Number(geolocation.latitude),
                  longitude: Number(geolocation.longitude),
                  markerColor: geolocation.markerColor,
                },
              ]
            : [];

          this.cdr.detectChanges();
        })
      )
      .subscribe();
  }
}
